import { VendorStatusInterface } from "../../models/ProcurementModule/VendorStatus";
import client from "../client";

class VendorStatusService {
  async GetAll(page: number, pageSize: number) {
    try {
      const { data } = await client.post<VendorStatusInterface[]>(
        `/api/VendorStatuses/get`,
        {
          page,
          pageSize,
        }
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      const { data } = await client.get<VendorStatusInterface>(
        `/api/VendorStatuses/getbyid/${id}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Create(item: VendorStatusInterface) {
    try {
      const { data } = await client.post<VendorStatusInterface>(
        `/api/VendorStatuses/create`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(id: string, item: VendorStatusInterface) {
    try {
      const { data } = await client.post<VendorStatusInterface>(
        `/api/VendorStatuses/update/${id}`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Remove(id: string) {
    try {
      const { data } = await client.post<VendorStatusInterface>(
        `/api/VendorStatuses/remove/${id}`,
        { url: "" }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new VendorStatusService();
